/**
 * Alpine.js data component for navigation sidebar
 * Securely handles sidebar state with validated persistence
 */
export function initNavigation() {
  if (typeof globalThis.Alpine === "undefined") {
    console.warn("[Navigation] Alpine.js is not available");
    return;
  }

  globalThis.Alpine.data("secureNavigation", () => ({
    /**
     * Validates and sanitizes the fullSize value from localStorage
     * Ensures only boolean values are accepted to prevent XSS
     * @returns {boolean} The validated fullSize state
     */
    fullSize: (() => {
      const storageKey = "_x_fullSize";
      const defaultValue = true;

      try {
        const storedValue = localStorage.getItem(storageKey);

        // If no value stored, return default
        if (storedValue === null) {
          return defaultValue;
        }

        // Parse the stored value
        const parsed = JSON.parse(storedValue);

        // Only accept boolean values
        if (typeof parsed === "boolean") {
          return parsed;
        }

        // If invalid type, remove corrupted value and return default
        console.warn(
          "[Navigation] Invalid fullSize value in localStorage, resetting to default",
        );
        localStorage.removeItem(storageKey);
        return defaultValue;
      } catch (error) {
        // If parsing fails, remove corrupted value and return default
        console.warn(
          "[Navigation] Failed to parse fullSize from localStorage, resetting to default",
        );
        localStorage.removeItem(storageKey);
        return defaultValue;
      }
    })(),

    init() {
      // Watch for state changes and persist to localStorage
      this.$watch("fullSize", (value) => {
        // Only persist boolean values
        if (typeof value === "boolean") {
          try {
            localStorage.setItem("_x_fullSize", JSON.stringify(value));
          } catch (error) {
            console.warn(
              `[Navigation] Failed to persist fullSize to localStorage: ${error.message}`,
            );
          }
        }
      });
    },
  }));
}
